import React from 'react';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import ShimmerAO from './ShimmerAO.js';
import ShimmerTabs from '../ShimmerUI/ShimmerTabs.js';
import ShimmerSelect from '../ShimmerUI/ShimmerSelect.js';
import ShimmerTable from '../ShimmerUI/ShimmerTable.js';
import ShimmerLineChart from '../ShimmerUI/ShimmerLineChart.js';
import Typography from '@mui/material/Typography';
import { Skeleton } from '@walmart-web/livingdesign-components';

export default function ShimmerGuidedInsights() {
	const useStyles = makeStyles(() => ({
		container: {
			border: '1px solid #dadce0',
			borderRadius: '8px',
			height: '422px',
			margin: '12px',
		},
		flexibleContainer: {
			border: '1px solid #dadce0',
			borderRadius: '8px',
			margin: '12px',
		},
		adShimmer: {
			margin: '22px !important',
		},
	}));

	const classes = useStyles();
	return (
		<Grid container>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<Box className={classes.container}>
					<ShimmerLineChart />
				</Box>
			</Grid>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<Box className={classes.container}>
					<ShimmerAO />
				</Box>
			</Grid>
			<Grid item xs={12} sm={12} md={12} lg={12}>
				<Box className={classes.flexibleContainer}>
					<div>
						<div>
							<Typography className={classes.adShimmer}>
								<Skeleton height="17.5px" width="129px" variant="rounded" />
							</Typography>
							<ShimmerTabs />
						</div>

						<Box sx={{ display: 'flex' }}>
							<ShimmerSelect /> <ShimmerSelect />
						</Box>
						<ShimmerTable />
					</div>
				</Box>
			</Grid>
		</Grid>
	);
}
